import PageLayout from "../../components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import PlansSection from "./components/PlansSection";
import OptionsSection from "./components/OptionsSection";
import NotesSection from "./components/NotesSection";
import FinalCTA from "./components/FinalCTA";

export default function Pricing() {
  return (
    <PageLayout>
      <HeroSection />
      <PlansSection />
      <OptionsSection />
      <NotesSection />
      <FinalCTA />
    </PageLayout>
  );
}